import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getNortonAccount,
  getNortonAccountPending,
} from '../../store/reducers';
import { TranslationService } from '@proximus/ng-common';
import { OnDestroyHookDirective } from '../../shared/hooks';

@Component({
  selector: 'mprd-norton-download',
  templateUrl: './norton-download.component.html',
  styleUrls: ['./norton-download.component.css'],
})
export class NortonDownloadComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  downloadLink: string;
  key: string;
  isPending = true;

  constructor(
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getNortonAccount).subscribe((value) => {
        if (value && value.nortonAccount) {
          this.key = value.nortonAccount.pin;
        }
        this.computeDownloadLink(this.key);
      }),
    );
    this.addSubscription(
      this.store.select(getNortonAccountPending).subscribe((value) => {
        this.isPending = value;
      }),
    );
  }

  private computeDownloadLink(key: string) {
    this.downloadLink = this.translationService
      .getTranslatedValueFor('norton.download.link')
      .replace(/\{0\}/g, key ? key : '');
  }
}
